module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/gabriela-brzozowska-29f321c378adc6f6a7ccd79b94704e04.png";